import React, { useCallback } from 'react';
import { NewUserType } from '~/components/Admin';
import { AdminServiceEvents, ServicesContext } from '~/services';
import { defaultApiResponseHandler } from '~/util';

export const useCreateUser = (events: AdminServiceEvents) => {
    const services = React.useContext(ServicesContext);

    const createUser = useCallback(
        async (user: NewUserType, options: ApiRequestOptionsType) => {
            try {
                const result = await services.api.call(
                    {
                        method: 'post',
                        url: '/api/users',
                        data: user,
                    },
                    options
                );

                // Publish event
                services.events.publish(events.user_created, result.data);

                return result.data;
            } catch (error) {
                throw defaultApiResponseHandler(error);
            }
        },
        [services.api, services.events, events.user_created]
    );

    return createUser;
};
